var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageLayout',{staticClass:"history-page"},[_c('PageTitle',{staticClass:"page-title"},[_vm._v("Історія замовлень")]),_c('InsuranceHomeInfo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }